import { OstFileResponse } from "./ost-file-response.model";
import { OstMailLabelsResponse } from "./ost-mail-labels-response.model";
import { ProdZonasDanadas } from "./req-ost.model";

export interface OstDispatchNoteResponse {
  labelId: string | null;
  status: string;
  path: string | null;
}

export class OstResponse {
  ostDistrictCode: number;
  ostDistrictName: string;
  ostHasDispatch: boolean;
  ostIsCreatedByInsurance: boolean;
  ostComentarioCierre: string;
  ostSubestadosHistorico: Array<string>;
  f11DniTransportista: string;
  ostRegion: string;
  ostEstadoGestionProducto: string;
  ostRetroventaNotes?: string;
  ostNegocio: string;
  ostPais: string;
  ostLocal: number;
  ostLocalNombre: string;
  ostNum: number;
  ostSeller: string;
  ostEstado: string;
  ostSubestado: string;
  ostFechaCompromiso: string;
  cliApellidoPaterno: string;
  cliApellidoMaterno: string;
  cliNombre: string;
  cliTipoDocumento: string;
  cliNumdocu: string;
  cliDv: string;
  prodNombre: string;
  prodNroActivo: string;
  prodSku: string;
  prodTipoGarantia: string;
  prodTipoGarantiaCode: string;
  ostFechaCreacion: string;
  ostFechaCierre: string;
  ostIsStoreRepair: boolean;
  stRut: string;
  stNombre: string;
  stFono: string;
  stSucursal: string;
  f11Reference: string;
  f11Num: number;
  stOtNum: string;
  stRegion: string;
  stComuna: string;
  stDireccion: string;
  prodEan: string;
  ostCodFalla: string;
  ostDescFalla: string;
  ostDetSintFalla: string;
  ostDetFallaCliente: string;
  prodBigTicket: boolean;
  ostFechaRecepProd: string;
  ostFechaEntrgaProd: string;
  ostEstadoProd: string;
  ostDetEstadoProd: string;
  cliEmailContacto: string;
  cliFonoContacto: string;
  ostCreadorNombre: string;
  ostCreadorTipoDocu: string;
  ostCreadorNumdocu: string;
  ostCreadorDv: string;
  ostCreadorSucursal: string;
  gcExiste: boolean;
  gcMontoAutorizado: string;
  gcFechaGeneracion: string;
  gcGeneracionNombre: string;
  gcGeneracionTipoDocu: string;
  gcGeneracionNumdocu: string;
  gcGeneracionDv: string;
  gcGeneracionSucursal: string;
  f11FechaDespacho: string;
  ostPreferenciaCli1: string;
  ostPreferenciaCli2: string;
  ostPreferenciaCli3: string;
  f11Tipo: string;
  cliDirCalle: string;
  prodDescripcion: string;
  prodModelo: string;
  prodMarca: string;
  prodNumeroSerie: string;
  prodPrecioCompra: number;
  prodGarantiaModalidad: string;
  prodGarantiaEstado: boolean;
  prodGarantiaFechaInicio: string;
  prodGarantiaFechaFin: string;
  prodPrecioActual: number;
  prodTieneAccesorio: boolean;
  invLocal: string;
  invTerminal: string;
  invNumBoleta: string;
  invFechaCompra: string;
  invIdVendedor: string;
  ostFechaUltMod: string;
  ostNumdocuUltMod: string;
  ostNomUltMod: string;
  ostTipoDocuUltMod: string;
  invMontoProd: number;
  invMontoBoleta: number;
  invComuna: string;
  invRegion: string;
  f11EstadoCreacion: boolean;
  f11NombreTransportista: string;
  f11PatenteTransportista: string;
  ostTieneEvidencia: boolean;
  prodLinea: string;
  prodSublinea: string;
  cliDirRegion: string;
  cliDirComuna: string;
  ostFechaOcurrencia: string;
  f11Motivo: string;
  f11Error: string | null;
  f11Estado: string;
  f11SubEstado: string;
  f11NumeroGuiaDespacho: string;
  prodClase: string;
  prodSubClase: string;
  subEstadoExterno?: string;
  ostFechaVisitaTecnicaAgendada: string;
  ostFechaVisitaTecnicaRealizada: string;
  ostFechaEntregaAgendada: string;
  ostSolucionServicioTecnico: string;
  ostIsF11Empresa: boolean;
  f11Metadata: Record<string, unknown>;
  mailLabels?: Array<OstMailLabelsResponse>;
  dispatchNotes?: Array<OstDispatchNoteResponse>;
  prodZonasDanadas: ProdZonasDanadas;
  ostFiles: OstFileResponse[];
  etiquetaCreada: boolean;
  gfMetadata?: Record<string, unknown>;

  constructor(
    ostDistrictCode?: number,
    ostDistrictName?: string,
    ostHasDispatch?: boolean,
    ostIsCreatedByInsurance?: boolean,
    ostComentarioCierre?: string,
    ostSubestadosHistorico?: Array<string>,
    f11DniTransportista?: string,
    ostRegion?: string,
    ostEstadoGestionProducto?: string,
    ostNegocio?: string,
    ostPais?: string,
    ostLocal?: number,
    ostLocalNombre?: string,
    ostNum?: number,
    ostSeller?: string,
    ostEstado?: string,
    ostSubestado?: string,
    cliApellidoPaterno?: string,
    cliApellidoMaterno?: string,
    cliNombre?: string,
    cliTipoDocumento?: string,
    cliNumdocu?: string,
    cliDv?: string,
    prodNombre?: string,
    prodNroActivo?: string,
    prodSku?: string,
    prodTipoGarantia?: string,
    prodTipoGarantiaCode?: string,
    ostFechaCreacion?: string,
    ostFechaCompromiso?: string,
    ostFechaCierre?: string,
    ostIsStoreRepair?: boolean,
    stRut?: string,
    stNombre?: string,
    stFono?: string,
    stSucursal?: string,
    f11Reference?: string,
    f11Num?: number,
    stOtNum?: string,
    stRegion?: string,
    stComuna?: string,
    stDireccion?: string,
    prodEan?: string,
    ostCodFalla?: string,
    ostDescFalla?: string,
    ostDetSintFalla?: string,
    ostDetFallaCliente?: string,
    prodBigTicket?: boolean,
    ostFechaRecepProd?: string,
    ostFechaEntrgaProd?: string,
    ostEstadoProd?: string,
    ostDetEstadoProd?: string,
    cliEmailContacto?: string,
    cliFonoContacto?: string,
    ostCreadorNombre?: string,
    ostCreadorTipoDocu?: string,
    ostCreadorNumdocu?: string,
    ostCreadorDv?: string,
    ostCreadorSucursal?: string,
    gcExiste?: boolean,
    gcMontoAutorizado?: string,
    gcFechaGeneracion?: string,
    gcGeneracionNombre?: string,
    gcGeneracionTipoDocu?: string,
    gcGeneracionNumdocu?: string,
    gcGeneracionDv?: string,
    gcGeneracionSucursal?: string,
    f11FechaDespacho?: string,
    ostPreferenciaCli1?: string,
    ostPreferenciaCli2?: string,
    ostPreferenciaCli3?: string,
    f11Tipo?: string,
    cliDirCalle?: string,
    prodDescripcion?: string,
    prodModelo?: string,
    prodMarca?: string,
    prodNumeroSerie?: string,
    prodPrecioCompra?: number,
    prodGarantiaModalidad?: string,
    prodGarantiaEstado?: boolean,
    prodGarantiaFechaInicio?: string,
    prodGarantiaFechaFin?: string,
    prodPrecioActual?: number,
    prodTieneAccesorio?: boolean,
    invLocal?: string,
    invTerminal?: string,
    invNumBoleta?: string,
    invFechaCompra?: string,
    invIdVendedor?: string,
    ostFechaUltMod?: string,
    ostNumdocuUltMod?: string,
    ostNomUltMod?: string,
    ostTipoDocuUltMod?: string,
    invMontoProd?: number,
    invMontoBoleta?: number,
    invComuna?: string,
    invRegion?: string,
    f11EstadoCreacion?: boolean,
    f11NombreTransportista?: string,
    f11PatenteTransportista?: string,
    ostTieneEvidencia?: boolean,
    prodLinea?: string,
    prodSublinea?: string,
    cliDirRegion?: string,
    cliDirComuna?: string,
    ostFechaOcurrencia?: string,
    f11Motivo?: string,
    f11Error?: string | null,
    f11Estado?: string,
    f11SubEstado?: string,
    f11NumeroGuiaDespacho?: string,
    prodClase?: string,
    prodSubClase?: string,
    subEstadoExterno?: string,
    ostFechaVisitaTecnicaAgendada?: string,
    ostFechaVisitaTecnicaRealizada?: string,
    ostFechaEntregaAgendada?: string,
    ostSolucionServicioTecnico?: string,
    ostIsF11Empresa?: boolean,
    f11Metadata?: Record<string, unknown>,
    mailLabels?: Array<OstMailLabelsResponse>,
    prodZonasDanadas?: ProdZonasDanadas,
    ostFiles?: OstFileResponse[],
    etiquetaCreada?: boolean,
    gfMetadata?: Record<string, unknown>
  ) {
    this.ostDistrictCode = ostDistrictCode ?? -1;
    this.ostDistrictName = ostDistrictName ?? "";
    this.ostHasDispatch = ostHasDispatch ?? false;
    this.ostIsCreatedByInsurance = ostIsCreatedByInsurance ?? false;
    this.ostComentarioCierre = ostComentarioCierre ?? "";
    this.ostSubestadosHistorico = ostSubestadosHistorico ?? [];
    this.f11DniTransportista = f11DniTransportista ?? "";
    this.ostRegion = ostRegion ?? "";
    this.ostEstadoGestionProducto = ostEstadoGestionProducto ?? "";
    this.ostNegocio = ostNegocio ?? "";
    this.ostPais = ostPais ?? "";
    this.ostLocal = ostLocal ?? -1;
    this.ostLocalNombre = ostLocalNombre ?? "";
    this.ostNum = ostNum ?? -1;
    this.ostSeller = ostSeller ?? "1P";
    this.ostEstado = ostEstado ?? "";
    this.ostSubestado = ostSubestado ?? "";
    this.cliApellidoPaterno = cliApellidoPaterno ?? "";
    this.cliApellidoMaterno = cliApellidoMaterno ?? "";
    this.cliNombre = cliNombre ?? "";
    this.cliTipoDocumento = cliTipoDocumento ?? "";
    this.cliNumdocu = cliNumdocu ?? "";
    this.cliDv = cliDv ?? "";
    this.prodNombre = prodNombre ?? "";
    this.prodNroActivo = prodNroActivo ?? "";
    this.prodSku = prodSku ?? "";
    this.prodTipoGarantia = prodTipoGarantia ?? "";
    this.prodTipoGarantiaCode = prodTipoGarantiaCode ?? "";
    this.ostFechaCreacion = ostFechaCreacion ?? "";
    this.ostFechaCompromiso = ostFechaCompromiso ?? "";
    this.ostFechaCierre = ostFechaCierre ?? "";
    this.ostIsStoreRepair = ostIsStoreRepair ?? false;
    this.stRut = stRut ?? "";
    this.stNombre = stNombre ?? "";
    this.stFono = stFono ?? "";
    this.stSucursal = stSucursal ?? "";
    this.f11Reference = f11Reference ?? "";
    this.f11Num = f11Num ?? -1;
    this.stOtNum = stOtNum ?? "";
    this.stRegion = stRegion ?? "";
    this.stComuna = stComuna ?? "";
    this.stDireccion = stDireccion ?? "";
    this.prodEan = prodEan ?? "";
    this.ostCodFalla = ostCodFalla ?? "";
    this.ostDescFalla = ostDescFalla ?? "";
    this.ostDetSintFalla = ostDetSintFalla ?? "";
    this.ostDetFallaCliente = ostDetFallaCliente ?? "";
    this.prodBigTicket = prodBigTicket ?? false;
    this.ostFechaRecepProd = ostFechaRecepProd ?? "";
    this.ostFechaEntrgaProd = ostFechaEntrgaProd ?? "";
    this.ostEstadoProd = ostEstadoProd ?? "";
    this.ostDetEstadoProd = ostDetEstadoProd ?? "";
    this.cliEmailContacto = cliEmailContacto ?? "";
    this.cliFonoContacto = cliFonoContacto ?? "";
    this.ostCreadorNombre = ostCreadorNombre ?? "";
    this.ostCreadorTipoDocu = ostCreadorTipoDocu ?? "";
    this.ostCreadorNumdocu = ostCreadorNumdocu ?? "";
    this.ostCreadorDv = ostCreadorDv ?? "";
    this.ostCreadorSucursal = ostCreadorSucursal ?? "";
    this.gcExiste = gcExiste ?? false;
    this.gcMontoAutorizado = gcMontoAutorizado ?? "";
    this.gcFechaGeneracion = gcFechaGeneracion ?? "";
    this.gcGeneracionNombre = gcGeneracionNombre ?? "";
    this.gcGeneracionTipoDocu = gcGeneracionTipoDocu ?? "";
    this.gcGeneracionNumdocu = gcGeneracionNumdocu ?? "";
    this.gcGeneracionDv = gcGeneracionDv ?? "";
    this.gcGeneracionSucursal = gcGeneracionSucursal ?? "";
    this.f11FechaDespacho = f11FechaDespacho ?? "";
    this.ostPreferenciaCli1 = ostPreferenciaCli1 ?? "";
    this.ostPreferenciaCli2 = ostPreferenciaCli2 ?? "";
    this.ostPreferenciaCli3 = ostPreferenciaCli3 ?? "";
    this.f11Tipo = f11Tipo ?? "";
    this.cliDirCalle = cliDirCalle ?? "";
    this.prodDescripcion = prodDescripcion ?? "";
    this.prodModelo = prodModelo ?? "";
    this.prodMarca = prodMarca ?? "";
    this.prodNumeroSerie = prodNumeroSerie ?? "";
    this.prodPrecioCompra = prodPrecioCompra ?? -1;
    this.prodGarantiaModalidad = prodGarantiaModalidad ?? "";
    this.prodGarantiaEstado = prodGarantiaEstado ?? false;
    this.prodGarantiaFechaInicio = prodGarantiaFechaInicio ?? "";
    this.prodGarantiaFechaFin = prodGarantiaFechaFin ?? "";
    this.prodPrecioActual = prodPrecioActual ?? -1;
    this.prodTieneAccesorio = prodTieneAccesorio ?? false;
    this.invLocal = invLocal ?? "";
    this.invTerminal = invTerminal ?? "";
    this.invNumBoleta = invNumBoleta ?? "";
    this.invFechaCompra = invFechaCompra ?? "";
    this.invIdVendedor = invIdVendedor ?? "";
    this.ostFechaUltMod = ostFechaUltMod ?? "";
    this.ostNumdocuUltMod = ostNumdocuUltMod ?? "";
    this.ostNomUltMod = ostNomUltMod ?? "";
    this.ostTipoDocuUltMod = ostTipoDocuUltMod ?? "";
    this.invMontoProd = invMontoProd ?? -1;
    this.invMontoBoleta = invMontoBoleta ?? -1;
    this.invComuna = invComuna ?? "";
    this.invRegion = invRegion ?? "";
    this.f11EstadoCreacion = f11EstadoCreacion ?? false;
    this.f11NombreTransportista = f11NombreTransportista ?? "";
    this.f11PatenteTransportista = f11PatenteTransportista ?? "";
    this.ostTieneEvidencia = ostTieneEvidencia ?? false;
    this.prodLinea = prodLinea ?? "";
    this.prodSublinea = prodSublinea ?? "";
    this.cliDirRegion = cliDirRegion ?? "";
    this.cliDirComuna = cliDirComuna ?? "";
    this.ostFechaOcurrencia = ostFechaOcurrencia ?? "";
    this.f11Motivo = f11Motivo ?? "";
    this.f11Error = f11Error ?? null;
    this.f11Estado = f11Estado ?? "";
    this.f11SubEstado = f11SubEstado ?? "";
    this.f11NumeroGuiaDespacho = f11NumeroGuiaDespacho ?? "";
    this.prodClase = prodClase ?? "";
    this.prodSubClase = prodSubClase ?? "";
    this.subEstadoExterno = subEstadoExterno ?? "";
    this.ostFechaVisitaTecnicaAgendada = ostFechaVisitaTecnicaAgendada ?? "";
    this.ostFechaVisitaTecnicaRealizada = ostFechaVisitaTecnicaRealizada ?? "";
    this.ostFechaEntregaAgendada = ostFechaEntregaAgendada ?? "";
    this.ostSolucionServicioTecnico = ostSolucionServicioTecnico ?? "";
    this.ostIsF11Empresa = ostIsF11Empresa ?? false;
    this.f11Metadata = f11Metadata ?? {};
    this.mailLabels = mailLabels ?? [];
    this.prodZonasDanadas = prodZonasDanadas ?? {
      abajo: false,
      atras: false,
      arriba: false,
      frente: false,
      derecho: false,
      izquierdo: false,
    };
    this.ostFiles = ostFiles ?? [];
    this.etiquetaCreada = etiquetaCreada ?? false;
    this.gfMetadata = gfMetadata ?? {};
  }
}
